import {
  Box,
  Button,
  Typography,
  Grid,
  Divider,
  FormControlLabel,
  Checkbox,
  Skeleton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";
import { useCallback, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { useHistory } from "react-router-dom";
import AlertConfirm from "components/ui/alert-confirm";
import AlertComplete from "components/ui/alert-complete";
import axios from "axios";
import { Cookies } from "react-cookie";
import { setAppData } from "assets/js/apphandle";
import { logoutAction } from "redux/reducers/user";
import { loadMainAction } from "redux/reducers/home";

const useStyles = makeStyles((theme) => ({
  leave: {
    "& .illust img": {
      marginLeft: rem(10),
    },
    "& .my-point": {
      padding: 0,
      "& .MuiGrid-item": {
        textAlign: "center",
        "& .label": {
          fontSize: rem(13),
        },
        "& .value": {
          marginTop: rem(10),
          fontSize: rem(24),
          fontWeight: 700,
          color: theme.palette.primary.main,
        },
      },
    },
    "& .list.spacing-10 li": {
      lineHeight: "22px",
    },
    "& .notice": {
      paddingBottom: rem(35),
      "& .list-num": {
        marginTop: 0,
        "& li": {
          marginTop: 0,
        },
      },
    },
    "& .MuiButton-root.Mui-disabled": {
      backgroundColor: "#bebebe",
    },
    "& .alert-font15": {
      fontSize: rem(15),
    },
  },
}));

export default function Leave(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [open, setOpen] = useState(false);
  const [openComp, setOpenComp] = useState(false);
  const [checked, setChecked] = useState();

  const cookies = new Cookies();
  const handleAlertClose = () => {
    setOpen(false);
  };

  const handleAlertCompClose = () => {
    setOpenComp(false);
  };

  const onLeave = () => {
    axios.post("/api/mb/member/leave").then((res) => {
      if (res.data.data) {
        setOpenComp(true);
      }
    });
  };

  const logout = (returnFunc) => {
    if (window.Android) {
      window.Android.logout(returnFunc);
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ios
    ) {
      // Call iOS interface
      var message = {
        command: "logout",
        func: returnFunc,
      };
      window.webkit.messageHandlers.ios.postMessage(message);
    } else {
      cookies.remove("X-AUTH-TOKEN", { path: "/" });
      cookies.remove("X-REFRESH-TOKEN", { path: "/" });
      cookies.remove("autoToken", { path: "/" });
      cookies.remove("no", { path: "/" });
      cookies.remove("favInfo", { path: "/" });
      dispatch(logoutAction());
      dispatch(
        loadMainAction({
          schTp: "1",
          schStore: "2701",
        })
      );
      window.location.href = "/";
    }
  };

  const [point, setPoint] = useState("");

  const loadData = () => {
    axios.get(`/api/mb/member/get-point`).then((res) => {
      setPoint(res.data.data);
    });
  };

  const getTitle = (cnt) => {
    return cnt > 99 ? "99+" : cnt;
  };

  const successLeave = () => {
    window.logoutReturnFunc6 = () => {
      cookies.remove("X-AUTH-TOKEN", { path: "/" });
      cookies.remove("X-REFRESH-TOKEN", { path: "/" });
      cookies.remove("autoToken", { path: "/" });
      cookies.remove("no", { path: "/" });
      cookies.remove("favInfo", { path: "/" });
      dispatch(logoutAction());
      dispatch(
        loadMainAction({
          schTp: "1",
          schStore: "2701",
        })
      );
      setAppData();
      window.location.href = "/";
    };
    handleAlertCompClose();
    logout("logoutReturnFunc6");
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    loadData();
  }, []);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "회원탈퇴", menu: true }));
  }, [init]);

  window.appBackKeyHandle = () => {
    if (open) {
      handleAlertClose();
    } else if (openComp) {
      successLeave();
    } else {
      history.goBack();
    }
  };

  return (
    <main id="main" className={"container " + classes.leave}>
      <Box className="box-type-1" style={{ paddingBottom: rem(35) }}>
        <h3 className="h3">
          탈퇴하시면 <br />
          아래 혜택이 사라져요!
        </h3>
        <Typography className="info-txt" mt={3}>
          회원탈퇴시 보유하고 계신 메가포인트, 상품권 전환금 등은 자동 소멸되어
          복원되지 않습니다.
        </Typography>

        <Box className="illust" mt={10}>
          <img src={`${process.env.PUBLIC_URL}/images/img/illust-leave.svg`} />
        </Box>

        <Grid container spacing={1} mt={6} className="my-point">
          <Grid item xs>
            <p className="label">쿠폰</p>
            <p className="value">{point && getTitle(point.couponCnt)}</p>
          </Grid>
          <Grid item xs>
            <p className="label">포인트</p>
            <p className="value">{point && point.point.toLocaleString()}</p>
          </Grid>
          <Grid item xs>
            <p className="label">상품권 전환금</p>
            <p className="value">{point && getTitle(point.tiketAmt)}</p>
          </Grid>
        </Grid>
      </Box>

      <Divider className="divider-type-2" />

      <Box className="box-type-1 notice">
        <p className="title">
          <i className="ico-noti" style={{ marginLeft: 0 }} />
          유의사항
        </p>
        <ul className="list list-dot color-info font-14 spacing-10">
          <li>
            회원탈퇴 후 재가입 시 신규회원으로 가입되며, 탈퇴전의 회원정보,
            주문정보, 결제수단 정보, 포인트 카드, 쿠폰은 복원되지 않습니다.
          </li>
          <li>
            부정 이용을 방지하기 위하여 사이트 정책에 따라 최대 30일 이내
            재가입이 불가합니다.
          </li>
          <li>
            진행 중인 주문/클레임, 정기배송 신청 건 등이 남아있는 경우는 해당
            사유가 해소된 이후 탈퇴가 가능합니다.
          </li>
          <li>
            개인정보는 재가입 유예기간 경과 후 즉시 파기됩니다. 단, 아래 정보는
            전자상거래법, 통신비밀보호법 등 관련 법령의 규정, 사이트의 이용약관
            및 개인정보 처리 방침에 의하여 일정기간 보관됩니다.
            <ul className="list list-num list-num-round font-14 color-info">
              <li>계약 또는 청약철회 등에 관한 기록 : 5년</li>
              <li>대금결제 및 재화 등의 공급에 관한 기록 : 5년</li>
              <li>소비자의 불만 또는 분쟁처리에 관한 기록 : 3년</li>
            </ul>
            <p>※보존이유 : 전자상거래등에서의 소비자보호에 관한 법률</p>
          </li>
        </ul>
      </Box>
      <Divider variant="middle" light />
      <Box className="box-type-2">
        <FormControlLabel
          value={checked}
          className="align-start"
          control={
            <Checkbox
              color="primary"
              icon={<span className="checkbox-icon" />}
              checkedIcon={<span className="checkbox-icon-checked" />}
            />
          }
          onChange={(e) => {
            setChecked(e.target.checked);
          }}
          label={
            <span className="font-15">
              본인은 회원탈퇴 유의사항 및 이용약관, 개인정보 처리 방침 내용을
              확인하였으며 동의합니다.
            </span>
          }
        />
      </Box>
      <Box className="box-type-6" mt={3}>
        <Button
          variant="contained"
          color="primary"
          disabled={!checked}
          fullWidth
          onClick={() => {
            setOpen(true);
          }}
        >
          다음
        </Button>
      </Box>
      <AlertConfirm
        open={open}
        handleAlertClose={handleAlertClose}
        text={
          "지금 탈퇴하시면 7일간 재가입 하실 수 없으세요. 그래도 탈퇴하시겠습니까?"
        }
        action={onLeave}
      />
      <AlertComplete
        open={openComp}
        handleAlertClose={successLeave}
        text="고객님의 회원탈퇴처리가 성공적으로 완료되었습니다."
        action={successLeave}
      />
    </main>
  );
}
